export default {"src":"/_next/static/media/undraw_alert.4ffefdba.svg","height":522,"width":931,"blurWidth":0,"blurHeight":0};